module.exports = __webpack_public_path__ + "img/shumeilogo-bar.bb8f4244.png";